import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=3ec8177e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=3ec8177e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8177e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec8177e')) {
      api.createRecord('3ec8177e', component.options)
    } else {
      api.reload('3ec8177e', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=3ec8177e&scoped=true", function () {
      api.rerender('3ec8177e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Register/PrivacyPolicy.vue"
export default component.exports